module.exports = __webpack_public_path__ + "static/media/famouslogo.f0898787.png";